import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const practiceAreasLinks = [
    { label: 'Kurumsal Hukuk', path: '/practice-areas/corporate-law' },
    { label: 'Ticari Dava', path: '/practice-areas/commercial-litigation' },
    { label: 'Gayrimenkul Hukuku', path: '/practice-areas/real-estate-law' },
  ];

  const aboutLinks = [
    { label: 'Hakkımızda', path: '/about' },
    { label: 'Avukatlarımız', path: '/attorneys' },
    { label: 'Kariyer', path: '/contact' },
  ];

  const resourcesLinks = [
    { label: 'Hukuki Görüşler', path: '/legal-insights' },
    { label: 'Başarı Hikayeleri', path: '/case-studies' },
    { label: 'SSS', path: '/contact' },
  ];

  const contactLinks = [
    { label: 'Ofis Konumu', path: '/contact' },
    { label: 'Danışmanlık', path: '/contact' },
    { label: 'E-posta', path: '/contact' },
  ];

  return (
    <footer className="bg-navy-900 text-white relative overflow-hidden">
      <div
        className="absolute inset-0 opacity-5"
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg width='100' height='100' viewBox='0 0 100 100' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M50 0 L100 50 L50 100 L0 50 Z' fill='%23C9A961' opacity='0.1'/%3E%3C/svg%3E")`,
          backgroundSize: '200px 200px',
        }}
      ></div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-12 pt-20 pb-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-12 mb-16">
          <div className="lg:col-span-4">
            <Link to="/" className="inline-block mb-6">
              <img
                src="https://public.readdy.ai/ai/img_res/6715b491-1985-4b8d-84c9-6d5ef3e7aa82.png"
                alt="Law Firm Logo"
                className="h-14 w-auto brightness-0 invert"
              />
            </Link>
            <p className="font-serif text-xl text-white/90 mb-8 leading-relaxed">
              Mükemmellik ve<br />
              Dürüstlük Üzerine Kurulu
            </p>
            <div className="flex items-center space-x-4">
              <input
                type="email"
                placeholder="E-posta adresiniz"
                className="flex-1 px-4 py-3 bg-transparent border border-gold-500/50 rounded-md text-sm text-white placeholder-white/50 focus:outline-none focus:border-gold-500"
              />
              <button className="w-12 h-12 flex items-center justify-center bg-gold-500 rounded-full hover:bg-gold-600 transition-colors cursor-pointer" aria-label="Subscribe">
                <i className="ri-mail-line text-navy-900 text-lg"></i>
              </button>
            </div>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-sans text-base font-semibold uppercase tracking-wider mb-6">
              Uzmanlık Alanları
            </h4>
            <ul className="space-y-4">
              {practiceAreasLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-sans text-base font-semibold uppercase tracking-wider mb-6">
              Hakkımızda
            </h4>
            <ul className="space-y-4">
              {aboutLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-sans text-base font-semibold uppercase tracking-wider mb-6">
              Kaynaklar
            </h4>
            <ul className="space-y-4">
              {resourcesLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <h4 className="font-sans text-base font-semibold uppercase tracking-wider mb-6">
              İletişim
            </h4>
            <ul className="space-y-4">
              {contactLinks.map((link) => (
                <li key={link.path}>
                  <Link
                    to={link.path}
                    className="text-sm text-white/70 hover:text-white transition-colors cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gold-500/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between space-y-4 md:space-y-0">
            <p className="text-sm text-white/60">
              © {currentYear} FP Hukuk ve Danışmanlık. Tüm hakları saklıdır.
            </p>

            <div className="flex items-center space-x-5">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/30 rounded-md hover:border-gold-500 hover:text-gold-500 transition-colors cursor-pointer"
                aria-label="LinkedIn"
              >
                <i className="ri-linkedin-line text-base"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/30 rounded-md hover:border-gold-500 hover:text-gold-500 transition-colors cursor-pointer"
                aria-label="Twitter"
              >
                <i className="ri-twitter-x-line text-base"></i>
              </a>
              <a
                href="https://instagram.com"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center border border-white/30 rounded-md hover:border-gold-500 hover:text-gold-500 transition-colors cursor-pointer"
                aria-label="Instagram"
              >
                <i className="ri-instagram-line text-base"></i>
              </a>
              <a
                href="mailto:info@lawfirm.com"
                className="w-9 h-9 flex items-center justify-center border border-white/30 rounded-md hover:border-gold-500 hover:text-gold-500 transition-colors cursor-pointer"
                aria-label="Email"
              >
                <i className="ri-mail-line text-base"></i>
              </a>
            </div>

            <div className="flex items-center space-x-8">
              <Link
                to="/privacy-policy"
                className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                Gizlilik Politikası
              </Link>
              <Link
                to="/terms-of-service"
                className="text-sm text-white/60 hover:text-white transition-colors cursor-pointer"
              >
                Hizmet Şartları
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;